<template>
  <SubContent h="550px" @back="toCancel">
    <template v-slot:nav_left> 编辑优秀苗子信息 </template>
    <div class="page-content">
      <div class="step-box">
        <!-- status: wait / process / finish / error / success -->
        <el-steps
          :active="activeStep"
          finish-status="success"
          process-status="wait"
          simple
        >
          <el-step title="评估信息"></el-step>
          <el-step title="专项评分"></el-step>
          <el-step title="主观评价"></el-step>
        </el-steps>
      </div>
      <div class="form_wrap" v-if="!isLoading">
        <vue-scroll>
          <div class="scroll-content form-content" style="margin: 0 20px">
            <el-form
              :inline="false"
              ref="form"
              :model="form"
              label-width="220px"
            >
              <div class="tr">
                <div class="td w240 content-center">
                  <span class="thead">评分项</span>
                </div>
                <div class="td">
                  <div style="display: flex; align-items: center; width: 100%; height: 100%;">
                    <span class="thead" style="flex: 1; text-align: center;">评分指标</span>
                    <el-button v-if="allowNoComment" type="primary" size="mini" @click="setAllNoComment" style="margin-right: 10px;">批量（本次未观察到）</el-button>
                    <el-button v-else="!allowNoComment" type="primary" size="mini" @click="setAllNoComment" style="margin-right: 10px;">撤销标记</el-button>
                  </div>
                </div>
              </div>

              <div class="tr" v-if="form.formTechnicalList && form.formTechnicalList.length>0">
                <div class="td w240 content-center">
                  <span>技术</span>
                </div>
                <div class="td">
                  <div
                    class="conten-wrapper sub-tr"
                    v-for="item in form.formTechnicalList"
                    :key="item.uuid"
                  >
                    <div class="sub-td" :title="item.indicatorParaphrase">
                      {{ item.indicatorName }}
                    </div>
                    <div class="sub-td" style="display: flex; justify-content: space-between; align-items: center; padding-right: 15px;">
                      <div>
                        <!-- 原有评分，增加 v-if -->
                        <el-rate v-if="!item.noComment" :allow-half="true" show-score score-template="{value}分" v-model="item.score"></el-rate>
                        <!-- 本次未观察到显示文字 -->
                        <span v-else style="color:#ccc;">本次未观察到</span>
                      </div>
                      <!-- 本次未观察到勾选框放在行最右侧，无单独td -->
                      <el-checkbox v-if="allowNoComment" v-model="item.noComment" @change="onNoCommentChange(item)">
                        <span style="color:#ccc;">本次未观察到</span>
                      </el-checkbox>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 战术 -->
              <div class="tr" v-if="form.formTacticalList && form.formTacticalList.length>0">
                <div class="td w240 content-center">
                  <span>战术</span>
                </div>
                <div class="td">
                  <div
                    class="conten-wrapper sub-tr"
                    v-for="item in form.formTacticalList"
                    :key="item.uuid"
                  >
                    <div class="sub-td" :title="item.indicatorParaphrase">
                      {{ item.indicatorName }}
                    </div>
                    <div class="sub-td" style="display: flex; justify-content: space-between; align-items: center; padding-right: 15px;">
                      <div>
                        <el-rate v-if="!item.noComment" :allow-half="true" show-score score-template="{value}分" v-model="item.score"></el-rate>
                        <span v-else style="color:#ccc;">本次未观察到</span>
                      </div>
                      <el-checkbox v-if="allowNoComment" v-model="item.noComment" @change="onNoCommentChange(item)">
                        <span style="color:#ccc;">本次未观察到</span>
                      </el-checkbox>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 身体 -->
              <div class="tr" v-if="form.formPhysicalList && form.formPhysicalList.length>0">
                <div class="td w240 content-center">
                  <span>身体</span>
                </div>
                <div class="td">
                  <div
                    class="conten-wrapper sub-tr"
                    v-for="item in form.formPhysicalList"
                    :key="item.uuid"
                  >
                    <div class="sub-td" :title="item.indicatorParaphrase">
                      {{ item.indicatorName }}
                    </div>
                    <div class="sub-td" style="display: flex; justify-content: space-between; align-items: center; padding-right: 15px;">
                      <div>
                        <el-rate v-if="!item.noComment" :allow-half="true" show-score score-template="{value}分" v-model="item.score"></el-rate>
                        <span v-else style="color:#ccc;">本次未观察到</span>
                      </div>
                      <el-checkbox
                        v-if="allowNoComment"
                        v-model="item.noComment"
                        @change="onNoCommentChange(item)"
                      ><span style="color:#ccc;">本次未观察到</span></el-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 心智 -->
              <div class="tr" v-if="form.formMentalList && form.formMentalList.length>0">
                <div class="td w240 content-center">
                  <span>心智</span>
                </div>
                <div class="td">
                  <div
                    class="conten-wrapper sub-tr"
                    v-for="item in form.formMentalList"
                    :key="item.uuid"
                  >
                    <div class="sub-td" :title="item.indicatorParaphrase">
                      {{ item.indicatorName }}
                    </div>
                    <div class="sub-td" style="display: flex; justify-content: space-between; align-items: center; padding-right: 15px;">
                      <div>
                        <el-rate v-if="!item.noComment" :allow-half="true" show-score score-template="{value}分" v-model="item.score"></el-rate>
                        <span v-else style="color:#ccc;">本次未观察到</span>
                      </div>
                      <el-checkbox
                        v-if="allowNoComment"
                        v-model="item.noComment"
                        @change="onNoCommentChange(item)"
                      ><span style="color:#ccc;">本次未观察到</span></el-checkbox>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 社交 -->
              <div class="tr" v-if="form.formSociMalList && form.formSociMalList.length>0">
                <div class="td w240 content-center">
                  <span>社交</span>
                </div>
                <div class="td">
                  <div
                    class="conten-wrapper sub-tr"
                    v-for="item in form.formSociMalList"
                    :key="item.uuid"
                  >
                    <div class="sub-td" :title="item.indicatorParaphrase">
                      {{ item.indicatorName }}
                    </div>
                    <div class="sub-td" style="display: flex; justify-content: space-between; align-items: center; padding-right: 15px;">
                      <div>
                        <el-rate v-if="!item.noComment" :allow-half="true" show-score score-template="{value}分" v-model="item.score"></el-rate>
                        <span v-else style="color:#ccc;">本次未观察到</span>
                      </div>
                      <el-checkbox v-if="allowNoComment" v-model="item.noComment" @change="onNoCommentChange(item)" >
                        <span style="color:#ccc;">本次未观察到</span>
                      </el-checkbox>
                    </div>
                  </div>
                </div>
              </div>

              <div class="tr" v-if="form.formra && form.formra.length>0">
                <div class="td w240 content-center">
                  <span>热爱</span>
                </div>
                <div class="td">
                  <div
                    class="conten-wrapper sub-tr"
                    v-for="item in form.formra"
                    :key="item.uuid"
                  >
                    <div class="sub-td" :title="item.indicatorParaphrase">
                      {{ item.indicatorName }}
                    </div>
                    <div class="sub-td" style="display: flex; justify-content: space-between; align-items: center; padding-right: 15px;">
                      <div>
                        <el-rate v-if="!item.noComment" :allow-half="true" show-score score-template="{value}分" v-model="item.score"></el-rate>
                        <span v-else style="color:#ccc;">本次未观察到</span>
                      </div>
                      <el-checkbox v-model="item.noComment" @change="onNoCommentChange(item)">
                        <span style="color:#ccc;">本次未观察到</span>
                      </el-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tr" v-if="form.formqg && form.formqg.length>0">
                <div class="td w240 content-center">
                  <span>球感</span>
                </div>
                <div class="td">
                  <div
                    class="conten-wrapper sub-tr"
                    v-for="item in form.formqg"
                    :key="item.uuid"
                  >
                    <div class="sub-td" :title="item.indicatorParaphrase">
                      {{ item.indicatorName }}
                    </div>
                    <div class="sub-td" style="display: flex; justify-content: space-between; align-items: center; padding-right: 15px;">
                      <div>
                        <el-rate v-if="!item.noComment" :allow-half="true" show-score score-template="{value}分" v-model="item.score"></el-rate>
                        <span v-else style="color:#ccc;">本次未观察到</span>
                      </div>
                      <el-checkbox v-model="item.noComment" @change="onNoCommentChange(item)">
                        <span style="color:#ccc;">本次未观察到</span>
                      </el-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tr" v-if="form.formqs && form.formqs.length>0">
                <div class="td w240 content-center">
                  <span>球商</span>
                </div>
                <div class="td">
                  <div
                    class="conten-wrapper sub-tr"
                    v-for="item in form.formqs"
                    :key="item.uuid"
                  >
                    <div class="sub-td" :title="item.indicatorParaphrase">
                      {{ item.indicatorName }}
                    </div>
                    <div class="sub-td" style="display: flex; justify-content: space-between; align-items: center; padding-right: 15px;">
                      <div>
                        <el-rate v-if="!item.noComment" :allow-half="true" show-score score-template="{value}分" v-model="item.score"></el-rate>
                        <span v-else style="color:#ccc;">本次未观察到</span>
                      </div>
                      <el-checkbox v-model="item.noComment" @change="onNoCommentChange(item)">
                        <span style="color:#ccc;">本次未观察到</span>
                      </el-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tr" v-if="form.formjc && form.formjc.length>0">
                <div class="td w240 content-center">
                  <span>决策速度</span>
                </div>
                <div class="td">
                  <div
                    class="conten-wrapper sub-tr"
                    v-for="item in form.formjc"
                    :key="item.uuid"
                  >
                    <div class="sub-td" :title="item.indicatorParaphrase">
                      {{ item.indicatorName }}
                    </div>
                    <div class="sub-td" style="display: flex; justify-content: space-between; align-items: center; padding-right: 15px;">
                      <div>
                        <el-rate v-if="!item.noComment" :allow-half="true" show-score score-template="{value}分" v-model="item.score"></el-rate>
                        <span v-else style="color:#ccc;">本次未观察到</span>
                      </div>
                      <el-checkbox v-model="item.noComment" @change="onNoCommentChange(item)">
                        <span style="color:#ccc;">本次未观察到</span>
                      </el-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tr" v-if="form.formwz && form.formwz.length>0">
                <div class="td w240 content-center">
                  <span>位置天赋</span>
                </div>
                <div class="td">
                  <div
                    class="conten-wrapper sub-tr"
                    v-for="item in form.formwz"
                    :key="item.uuid"
                  >
                    <div class="sub-td" :title="item.indicatorParaphrase">
                      {{ item.indicatorName }}
                    </div>
                    <div class="sub-td" style="display: flex; justify-content: space-between; align-items: center; padding-right: 15px;">
                      <div>
                        <el-rate v-if="!item.noComment" :allow-half="true" show-score score-template="{value}分" v-model="item.score"></el-rate>
                        <span v-else style="color:#ccc;">本次未观察到</span>
                      </div>
                      <el-checkbox v-model="item.noComment" @change="onNoCommentChange(item)">
                        <span style="color:#ccc;">本次未观察到</span>
                      </el-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tr" v-if="form.formjsl && form.formjsl.length>0">
                <div class="td w240 content-center">
                  <span>精神力</span>
                </div>
                <div class="td">
                  <div
                    class="conten-wrapper sub-tr"
                    v-for="item in form.formjsl"
                    :key="item.uuid"
                  >
                    <div class="sub-td" :title="item.indicatorParaphrase">
                      {{ item.indicatorName }}
                    </div>
                    <div class="sub-td" style="display: flex; justify-content: space-between; align-items: center; padding-right: 15px;">
                      <div>
                        <el-rate v-if="!item.noComment" :allow-half="true" show-score score-template="{value}分" v-model="item.score"></el-rate>
                        <span v-else style="color:#ccc;">本次未观察到</span>
                      </div>
                      <el-checkbox v-model="item.noComment" @change="onNoCommentChange(item)">
                        <span style="color:#ccc;">本次未观察到</span>
                      </el-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tr" v-if="form.formst && form.formst.length>0">
                <div class="td w240 content-center">
                  <span>身体</span>
                </div>
                <div class="td">
                  <div
                    class="conten-wrapper sub-tr"
                    v-for="item in form.formst"
                    :key="item.uuid"
                  >
                    <div class="sub-td" :title="item.indicatorParaphrase">
                      {{ item.indicatorName }}
                    </div>
                    <div class="sub-td" style="display: flex; justify-content: space-between; align-items: center; padding-right: 15px;">
                      <div>
                        <el-rate v-if="!item.noComment" :allow-half="true" show-score score-template="{value}分" v-model="item.score"></el-rate>
                        <span v-else style="color:#ccc;">本次未观察到</span>
                      </div>
                      <el-checkbox v-model="item.noComment" @change="onNoCommentChange(item)">
                        <span style="color:#ccc;">本次未观察到</span>
                      </el-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tr" v-if="form.formgt && form.formgt.length>0">
                <div class="td w240 content-center">
                  <span>沟通</span>
                </div>
                <div class="td">
                  <div
                    class="conten-wrapper sub-tr"
                    v-for="item in form.formgt"
                    :key="item.uuid"
                  >
                    <div class="sub-td" :title="item.indicatorParaphrase">
                      {{ item.indicatorName }}
                    </div>
                    <div class="sub-td" style="display: flex; justify-content: space-between; align-items: center; padding-right: 15px;">
                      <div>
                        <el-rate v-if="!item.noComment" :allow-half="true" show-score score-template="{value}分" v-model="item.score"></el-rate>
                        <span v-else style="color:#ccc;">本次未观察到</span>
                      </div>
                      <el-checkbox v-model="item.noComment" @change="onNoCommentChange(item)">
                        <span style="color:#ccc;">本次未观察到</span>
                      </el-checkbox>
                    </div>
                  </div>
                </div>
              </div>

            </el-form>
          </div>
        </vue-scroll>
      </div>
      <yioks-tips :showTip="tipsFlag" :tipMsg="tipMsg" :loading="repeatSubmit" @callback="hideTipsDialog"></yioks-tips>
      <yioks-tips :showTip="tipsFlagNext" tipMsg="请确认保存并进入下一步？" :loading="repeatNext" @callback="hideTipsDialogNext"></yioks-tips>
      <yioks-tips :showTip="tipsFlagCancel" tipMsg="请确认放弃保存并返回吗？" :loading="repeatSubmitCancel" @callback="hideTipsDialogCancel"></yioks-tips>
    </div>

    <template v-slot:btn>
      <div class="btn_wrap">
        <el-button type="primary" @click="preNext">上一步</el-button>
        <el-button type="primary" @click="templateSave">暂时保存</el-button>
        <el-button
          type="primary"
          @click="toNext(true)"
          >下一步</el-button
        >
        <el-button type="danger" @click="toCancel">取消</el-button>
      </div>
    </template>
  </SubContent>
</template>

<script>
import scout from "@/api/scout";
import player from "@/api/player"; // getPlayerInfo获取球员信息
import storage from "@/utils/storage";

export default {
  name: "EditRate",

  data() {
    return {
      tipsFlag: false,
      repeatSubmit: false,
      tipsFlagCancel: false,
      repeatSubmitCancel: false,
      repeatNext: false,
      tipsFlagNext: false,
      tipMsg:"请确认暂时保存并退出？",
      pre:0,
      userRole: storage.get("userInfo").userRole,
      uuid: storage.get("userInfo").uuid,
      activeStep: 2,
      technicalList: [], //技术列表
      tacticalList: [], //战术列表
      physicalList: [], // 身体列表
      mentalList: [], // 心智列表
      socialList: [], // 社交列表
      ra:[],
      qg:[],
      qs:[],
      jc:[],
      wz:[],
      jsl:[],
      st:[],
      gt:[],
      // 新增：全局开关
      allowNoComment: true,
      form: {
        formTechnicalList: [], //技术列表
        formTacticalList: [], //战术列表
        formPhysicalList: [], // 身体列表
        formMentalList: [], // 心智列表
        formSociMalList: [], // 社交列表
        formra:[],
        formqg:[],
        formqs:[],
        formjc:[],
        formwz:[],
        formjsl:[],
        formst:[],
        formgt:[],
      },
      isLoading: false,
    };
  },

  components: {
    SubContent: () => import("@/components/layout/contentWithbtn"),
    'yioks-tips': () => import('@/components/YioksTip')
  },

  computed: {
    playerUuid() {
      const uuid = this.$route.query.playerUuid || "";
      return uuid;
    },

    dataUuid() {
      const uuid = this.$route.query.dataUuid || "";
      return uuid;
    },
    scoutType() {
      const scoutType = this.$route.query.scoutType || "";
      return scoutType;
    },
  },


  mounted() {
    this.loadScoutRateInfo();
  },

  methods: {
    // 切换本次未观察到时清空/恢复分数
    onNoCommentChange(item) {
      if (item.noComment) {
        item.score = null; // 本次未观察到 = 空
      } else {
        item.score = 0; // 取消本次未观察到 = 0分
      }
    },

    // 一键勾选、取消勾选所有本次未观察到状态
    setAllNoComment() {
      const allList = [
        ...this.form.formTechnicalList,
        ...this.form.formTacticalList,
        ...this.form.formPhysicalList,
        ...this.form.formMentalList,
        ...this.form.formSociMalList,
        ...this.form.formra,
        ...this.form.formqg,
        ...this.form.formqs,
        ...this.form.formjc,
        ...this.form.formwz,
        ...this.form.formjsl,
        ...this.form.formst,
        ...this.form.formgt,
      ];
      if (this.allowNoComment) {
        this.allowNoComment = false;
        allList.forEach(item => {
          item.noComment = true;
          item.score = null;
        });
      } else {
        this.allowNoComment = true;
        allList.forEach(item => {
          item.noComment = false;
          if (item.score === null) item.score = 0;
        });
      }
    },

    /* 上一步 */
     preNext() {
       this.tipMsg="请确认保存并返回上一步吗？"
       this.pre = 1;
       this.tipsFlag = true
    },


    /* 暂时保存 */
    hideTipsDialog(ok) {
      if (ok){
        if (!this.repeatSubmit) {
          this.repeatSubmit = true
          const {
            formMentalList,
            formPhysicalList,
            formSociMalList,
            formTacticalList,
            formTechnicalList,
            formra,
            formqg,
            formqs,
            formjc,
            formwz,
            formjsl,
            formst,
            formgt,
          } = this.form;
          let aimArr = [
            ...formMentalList,
            ...formPhysicalList,
            ...formSociMalList,
            ...formTacticalList,
            ...formTechnicalList,
            ...formra,
            ...formqg,
            ...formqs,
            ...formjc,
            ...formwz,
            ...formjsl,
            ...formst,
            ...formgt,
          ];
          aimArr = aimArr.map((item) => ({
            score: item.score,// 已支持 null
            uuid: item.uuid,
            dataUuid: item.dataUuid,
          }));

          scout
          .postScoutRateEditInfo(aimArr)
          .then(res => {
            if (res.code) {
              this.$message.error(res.msg)
              this.repeatSubmit = false
              this.tipsFlag = false
            } else {
              this.$message.success("信息保存成功！~");
              this.repeatSubmit = false
              this.tipsFlag = false
              if (this.pre === 1){
                this.$router.go(-1)
              } else {
                this.$router.push({
                  name: "ScoutList",
                });
              }
            }
          })
          .catch((err) => {
            this.repeatSubmit = false
            this.tipsFlag = false
            console.log(err);
          });
        }
      }  else {
        this.repeatSubmit = false
        this.tipsFlag = false
      }
    },
    hideTipsDialogNext(ok){
      if (ok){
        if (!this.repeatNext) {
          this.repeatNext = true
          this.handleSubmiteData();
          this.repeatNext = false
          this.tipsFlagNext = false
        }
      } else {
        this.repeatNext = false
        this.tipsFlagNext = false
      }

    },
    templateSave () {
      this.pre = 0
      this.tipsFlag = true
    },
    /* 下一步 */
    toNext(status) {
      this.tipsFlagNext = true
    },

    /* 处理表单数据 */
    handleSubmiteData() {
      const {
        formMentalList,
        formPhysicalList,
        formSociMalList,
        formTacticalList,
        formTechnicalList,
        formra,
        formqg,
        formqs,
        formjc,
        formwz,
        formjsl,
        formst,
        formgt,
      } = this.form;
      let aimArr = [
        ...formMentalList,
        ...formPhysicalList,
        ...formSociMalList,
        ...formTacticalList,
        ...formTechnicalList,
        ...formra,
        ...formqg,
        ...formqs,
        ...formjc,
        ...formwz,
        ...formjsl,
        ...formst,
        ...formgt,
      ];
      aimArr = aimArr.map((item) => ({
        score: item.score, // 支持提交 null
        uuid: item.uuid,
        dataUuid: item.dataUuid,
      }));

      scout
        .postScoutRateEditInfo(aimArr)
        .then((res) => {
          if (res.code) {
            this.$message.error(res.msg)
            this.repeatNext = false
            this.tipsFlagNext = false
          } else {
            this.$router.push({
              name: "EditComment",
              query: {
                dataUuid: this.dataUuid,
                playerUuid: this.playerUuid,
              },
            });
          }
        })
        .catch((err) => {
          this.repeatNext = false
          this.tipsFlagNext = false
          console.log(err);
        });
    },
    /* 取消 */
    toCancel() {
      this.tipsFlagCancel = true
    },
    hideTipsDialogCancel (ok) {
      if (ok){
        this.repeatSubmitCancel = false
        this.tipsFlagCancel = false
        this.$router.push({
          name: "ScoutList",
        });
      }else {
        this.repeatSubmitCancel = false
        this.tipsFlagCancel = false
      }
    },
    /* 获取评分项 */
    loadRateItem() {
      const type = this.scoutType;
      scout
        .getRateList(type)
        .then((res) => {
          let technicalList = [];
          let tacticalList = [];
          let physicalList = [];
          let mentalList = [];
          let socialList = [];
          let otherList = []; // 冗余信息
          let ra=[];
          let qg=[];
          let qs=[];
          let jc=[];
          let wz=[];
          let jsl=[];
          let st=[];
          let gt=[];
          res.forEach((item) => {
            if (item.indicatorType === "technical") {
              technicalList.push(item);
            }
            if (item.indicatorType === "tactical") {
              tacticalList.push(item);
            }
            if (item.indicatorType === "physical") {
              physicalList.push(item);
            }
            if (item.indicatorType === "mental") {
              mentalList.push(item);
            }
            if (item.indicatorType === "social") {
              socialList.push(item);
            }
            if (item.indicatorType === "热爱") {
              ra.push(item);
            }
            if (item.indicatorType === "球感") {
              qg.push(item);
            }
            if (item.indicatorType === "球商") {
              qs.push(item);
            }
            if (item.indicatorType === "决策速度") {
              jc.push(item);
            }
            if (item.indicatorType === "位置天赋") {
              wz.push(item);
            }
            if (item.indicatorType === "精神力") {
              jsl.push(item);
            }
            if (item.indicatorType === "身体") {
              st.push(item);
            }
            if (item.indicatorType === "沟通") {
              gt.push(item);
            }
          });

          this.technicalList = technicalList;
          this.tacticalList = tacticalList;
          this.physicalList = physicalList;
          this.mentalList = mentalList;
          this.socialList = socialList;
          this.ra = ra;
          this.qg = qg;
          this.qs = qs;
          this.jc = jc;
          this.wz = wz;
          this.jsl = jsl;
          this.st = st;
          this.gt = gt;

          this.formateDataTodealForm();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    /* 表单数据构造 */
    formateDataTodealForm() {
      const playerUuid = this.playerUuid;
      const dataUuid = this.dataUuid;

      // 给每条评分增加 noComment 字段
      let formTechnicalList = this.technicalList.map((item) => ({
        score: 0,
        indicatorName: item.indicatorName,
        indicatorParaphrase: item.indicatorParaphrase,
        playerUuid,
        dataUuid,
        indicatorUuid: item.uuid,
        noComment: false,
      }));

      let formTacticalList = this.tacticalList.map((item) => ({
        score: 0,
        indicatorName: item.indicatorName,
        indicatorParaphrase: item.indicatorParaphrase,
        playerUuid,
        dataUuid,
        indicatorUuid: item.uuid,
        noComment: false,
      }));

      let formPhysicalList = this.physicalList.map((item) => ({
        score: 0,
        indicatorName: item.indicatorName,
        indicatorParaphrase: item.indicatorParaphrase,
        playerUuid,
        dataUuid,
        indicatorUuid: item.uuid,
        noComment: false,
      }));

      let formMentalList = this.mentalList.map((item) => ({
        score: 0,
        indicatorName: item.indicatorName,
        indicatorParaphrase: item.indicatorParaphrase,
        playerUuid,
        dataUuid,
        indicatorUuid: item.uuid,
        noComment: false,
      }));

      let formSociMalList = this.socialList.map((item) => ({
        score: 0,
        indicatorName: item.indicatorName,
        indicatorParaphrase: item.indicatorParaphrase,
        playerUuid,
        dataUuid,
        indicatorUuid: item.uuid,
        noComment: false,
      }));

      let formra = this.ra.map((item) => ({
        score: 0,
        indicatorName: item.indicatorName,
        indicatorParaphrase: item.indicatorParaphrase,
        dataUuid,
        indicatorUuid: item.uuid,
        noComment: false,
      }));

      let formqg = this.qg.map((item) => ({
        score: 0,
        indicatorName: item.indicatorName,
        indicatorParaphrase: item.indicatorParaphrase,
        dataUuid,
        indicatorUuid: item.uuid,
        noComment: false,
      }));

      let formqs = this.qs.map((item) => ({
        score: 0,
        indicatorName: item.indicatorName,
        indicatorParaphrase: item.indicatorParaphrase,
        dataUuid,
        indicatorUuid: item.uuid,
        noComment: false,
      }));

      let formjc = this.jc.map((item) => ({
        score: 0,
        indicatorName: item.indicatorName,
        indicatorParaphrase: item.indicatorParaphrase,
        dataUuid,
        indicatorUuid: item.uuid,
        noComment: false,
      }));

      let formwz = this.wz.map((item) => ({
        score: 0,
        indicatorName: item.indicatorName,
        indicatorParaphrase: item.indicatorParaphrase,
        dataUuid,
        indicatorUuid: item.uuid,
        noComment: false,
      }));

      let formjsl = this.jsl.map((item) => ({
        score: 0,
        indicatorName: item.indicatorName,
        indicatorParaphrase: item.indicatorParaphrase,
        dataUuid,
        indicatorUuid: item.uuid,
        noComment: false,
      }));

      let formst = this.st.map((item) => ({
        score: 0,
        indicatorName: item.indicatorName,
        indicatorParaphrase: item.indicatorParaphrase,
        dataUuid,
        indicatorUuid: item.uuid,
        noComment: false,
      }));

      let formgt = this.gt.map((item) => ({
        score: 0,
        indicatorName: item.indicatorName,
        indicatorParaphrase: item.indicatorParaphrase,
        dataUuid,
        indicatorUuid: item.uuid,
        noComment: false,
      }));

      this.$set(this.form, "formTechnicalList", formTechnicalList);
      this.$set(this.form, "formTacticalList", formTacticalList);
      this.$set(this.form, "formPhysicalList", formPhysicalList);
      this.$set(this.form, "formMentalList", formMentalList);
      this.$set(this.form, "formSociMalList", formSociMalList);
      this.$set(this.form, "formra", formra);
      this.$set(this.form, "formqg", formqg);
      this.$set(this.form, "formqs", formqs);
      this.$set(this.form, "formjc", formjc);
      this.$set(this.form, "formwz", formwz);
      this.$set(this.form, "formjsl", formjsl);
      this.$set(this.form, "formst", formst);
      this.$set(this.form, "formgt", formgt);
    },

    /* 获取评分 */
    loadScoutRateInfo() {
      this.isLoading = true;
      const uuid = this.dataUuid;
      scout
        .getScoutRateInfo(uuid)
        .then((res) => {
          this.isLoading = false;
          let technicalList = [];
          let tacticalList = [];
          let physicalList = [];
          let mentalList = [];
          let socialList = [];
          let otherList = []; // 冗余信息
          let ra=[];
          let qg=[];
          let qs=[];
          let jc=[];
          let wz=[];
          let jsl=[];
          let st=[];
          let gt=[];
          res.forEach((item) => {
            // 处理 score 字段不存在或为空的情况
            if (item.score === undefined || item.score === null || item.score === '') {
              item.score = null;
              item.noComment = true; // 没有分数则标记为本次未观察到，勾选框会勾选
            } else {
              try {
                item.score = JSON.parse(item.score);
                item.noComment = item.score === null;
              } catch (e) {
                // 如果解析失败，也视为本次未观察到
                item.score = null;
                item.noComment = true;
              }
            }

            if (item.indicatorType === "technical") {
              technicalList.push(item);
            }
            if (item.indicatorType === "tactical") {
              tacticalList.push(item);
            }
            if (item.indicatorType === "physical") {
              physicalList.push(item);
            }
            if (item.indicatorType === "mental") {
              mentalList.push(item);
            }
            if (item.indicatorType === "social") {
              socialList.push(item);
            }
            if (item.indicatorType === "热爱") {
              ra.push(item);
            }
            if (item.indicatorType === "球感") {
              qg.push(item);
            }
            if (item.indicatorType === "球商") {
              qs.push(item);
            }
            if (item.indicatorType === "决策速度") {
              jc.push(item);
            }
            if (item.indicatorType === "位置天赋") {
              wz.push(item);
            }
            if (item.indicatorType === "精神力") {
              jsl.push(item);
            }
            if (item.indicatorType === "身体") {
              st.push(item);
            }
            if (item.indicatorType === "沟通") {
              gt.push(item);
            }
          });

          this.technicalList = technicalList;
          this.tacticalList = tacticalList;
          this.physicalList = physicalList;
          this.mentalList = mentalList;
          this.sociMalList = socialList;
          this.ra = ra;
          this.qg = qg;
          this.qs = qs;
          this.jc = jc;
          this.wz = wz;
          this.jsl = jsl;
          this.st = st;
          this.gt = gt;

          this.$set(this.form, "formTechnicalList", this.technicalList);
          this.$set(this.form, "formTacticalList", this.tacticalList);
          this.$set(this.form, "formPhysicalList", this.physicalList);
          this.$set(this.form, "formMentalList", this.mentalList);
          this.$set(this.form, "formSociMalList", this.sociMalList);
          this.$set(this.form, "formra", ra);
          this.$set(this.form, "formqg", qg);
          this.$set(this.form, "formqs", qs);
          this.$set(this.form, "formjc", jc);
          this.$set(this.form, "formwz", wz);
          this.$set(this.form, "formjsl", jsl);
          this.$set(this.form, "formst", st);
          this.$set(this.form, "formgt", gt);
        })
        .catch((err) => {
          this.isLoading = false;
          console.error(err);
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable';

.form_wrap {
  padding: 20px 20px 60px;
  overflow: hidden;
  box-sizing: border-box;
  flex: 1;
  font-size: 16px;
  height: 500px;
}

.step-box {
  margin-top: 10px;
}

.btn_wrap {
  width: 100%;
  display: flex;
  justify-content: center;
}

.w380 {
  width: 380px;
}

.form-content {
  span.thead {
    height: 40px;
    font-size: 18px;
    font-weight: 600;
    line-height: 40px;
    text-align: center;
  }

  .label-wrapper, .conten-wrapper {
    width: 100%;
  }
}

.tr {
  display: flex;
  width: 100%;
  border: 1px solid #fff;
  border-bottom: none;

  &:last-child {
    border-bottom: 1px solid #fff;
  }
}

.td {
  border-right: 1px solid #fff;
  width: 100%;

  &:last-child {
    border-right: none;
  }
}

.sub-tr {
  display: flex;
  width: 100%;
  border-bottom: 1px dashed #fff;
  height: 32px;
  line-height: 32px;

  &:last-child {
    border-bottom: none;
  }
}

.sub-td {
  width: 100%;
  border-right: 1px dashed #fff;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-left: 25px;

  &:last-child {
    border-right: none;
  }
}

.content-text {
  text-indent: 2em;
  height: 24px;
  line-height: 24px;
}

.w240 {
  width: 240px;
}

.w500 {
  width: 500px;
}

.content-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<style lang="stylus">
.page-content {
  .el-steps--simple {
    background-color: rgba(0, 0, 0, 0);
  }

  .el-form-item__label {
    color: #fff;
    font-size: 16px;
  }
  .el-rate__text {
    color:#fff !important;
  }
}
</style>
